export default __webpack_public_path__ + "static/media/icon_location.601014a9.svg";